import { Modal } from "@pg-flex/shared-js/ui/Modal";
import { Spinner } from "@pg-flex/shared-js/ui/Spinner";
import { gettext } from "@pg-flex/shared-js/utils/i18n";
import { wrapImportAsDefault } from "@pg-flex/shared-js/utils/lazy";
import React, {
  ComponentProps,
  Suspense,
  ComponentType,
  ReactNode,
} from "react";

import { FullBox } from "@/components/FullBox";
// import { ScreenContainer } from "@/components/ScreenContainer";

export const lazy = <
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  T extends ComponentType<any>,
  CompName extends string,
  Mod extends { [k in CompName]: T },
>(
  type: /* "screen" |*/ "modal" | "box",
  importer: () => Promise<Mod>,
  compName: CompName
) => {
  let fallbackComp: ReactNode;
  switch (type) {
    // case "screen":
    //   fallbackComp = (
    //     <ScreenContainer
    //       title=""
    //       style={{
    //         display: "flex",
    //         alignItems: "center",
    //         justifyContent: "center",
    //       }}
    //     >
    //       <Spinner />
    //     </ScreenContainer>
    //   );
    //   break;
    case "modal":
      fallbackComp = (
        <Modal isOpen>
          <Spinner />
        </Modal>
      );
      break;
    case "box":
      fallbackComp = <FullBox>{gettext("Loading…")}</FullBox>;
      break;
  }
  const Component = React.lazy(() => wrapImportAsDefault(importer(), compName));
  return function LazyComponent(props: ComponentProps<Mod[CompName]>) {
    return (
      <Suspense fallback={fallbackComp}>
        <Component {...props} />
      </Suspense>
    );
  };
};
